<template>
    <div v-if="categoryExits"
         :class="classes"
         @click="toggle">
        <div>{{ name }}</div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import Icon from '../base/Icon.vue';

@Component({
    components: { Icon }
})
export default class CategoryArticle extends Vue {
    @Inject({
        default: () => null
    }) readonly registerCategory!: Function;

    @Prop({ required: true }) name: string;
    @Prop({ required: true }) categoryId: string;
    @Prop({ required: true }) categoryKey: string;
    @Prop({ required: true }) categoryActive: string[];
    @Prop({ default: false }) pill: boolean;
    @Prop({ default: false, type: Boolean }) multi: boolean;

    categoryAvailable = true;
    categoryExits = true;
    checked = false;

    mounted() {
        this.registerCategory(this);
    }

    toggle() {
        // for single selection we can ignore disabled categories
        if (this.categoryAvailable || !this.multi) {
            this.checked = !this.checked;
            this.$emit('toggle', {
                id: this.categoryId,
                name: this.name,
                key: this.categoryKey,
                checked: this.checked
            });
        }
    }

    get classes() {
        let style = '';
        if (this.pill) {
            style = 'px-4 md:px-6 h-14 md:h-20 rounded-mid border flex-shrink-0 flex justify-center items-center transition-colors cursor-pointer ';
            style += this.categoryActive.includes(this.categoryKey) ? 'bg-red text-white border-red' : 'border-opacity-50 border-gray hover:bg-white';
        } else {
            style = 'dropdown-item';
            if (this.multi) {
                style += ' dropdown-item--multi';
            }
            if (this.categoryActive.includes(this.categoryKey) && this.categoryAvailable) {
                style += ' dropdown-item--active';
            }
            if (!this.categoryAvailable) {
                style += ' dropdown-item--disabled';
            }
        }
        return style;
    }
}
</script>
